import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { GETTING_PARENTS, GET_PARENTS, PARENTS_ERROR } from "../types"


export const fetchParents = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/parents?expand=userProfile`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_PARENTS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_PARENTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: PARENTS_ERROR,
            error
        })
    }
}
